import React, {useState} from 'react';
import {Button, Dialogue, Text} from '@albert-io/atomic';
import {callAction} from 'client/framework';
import sessionLifecycleActions from 'client/Session/SessionLifecycleActions';

type CleverReloginDialogueProps = {onCancel: () => void};

/**
 * Prompts a teacher to re-authenticate with Clever. Shown when a sync attempt
 * cannot resolve their Clever identity (no SSO login and no email match).
 */
export const CleverReloginDialogue = ({onCancel}: CleverReloginDialogueProps) => {
  const [loggingOut, setLoggingOut] = useState(false);

  return (
    <Dialogue inModal size='s' hideCloseBtn>
      <Dialogue.Body align='center'>
        <Text>
          Before you can import and sync, you&apos;ll need to log out of Albert and log back in with
          Clever.
        </Text>
        <div className='mt-x5 gap-x1 flex flex-col'>
          <Button
            data-testid='clever-relogin-dialogue__log-out-btn'
            disabled={loggingOut}
            onClick={() => {
              setLoggingOut(true);
              callAction(sessionLifecycleActions.END_SESSION);
            }}
          >
            {loggingOut ? 'Logging out...' : 'Log Out Of Albert'}
          </Button>
          <Button
            data-testid='clever-relogin-dialogue__cancel-btn'
            variant='outlined'
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </Dialogue.Body>
    </Dialogue>
  );
};
